import React from 'react';

const PrivacyPolicyES: React.FC = () => {
  return (
    <div className="prose max-w-none">
      <section className="mb-8">
        <h2 className="text-2xl font-semibold text-gray-800 mb-4">1. Introducción</h2>
        <p className="mb-4">
          BIXMO SRL ("nosotros," "nuestro," o "nos") opera la aplicación móvil y sitio web GatherPlay (el "Servicio"). 
          Esta Política de Privacidad explica cómo recopilamos, usamos y protegemos la información cuando utilizas nuestro Servicio.
        </p>
        <div className="bg-gray-100 p-4 rounded-lg mb-4">
          <p><strong>Información de Contacto:</strong></p>
          <ul className="list-none mt-2 space-y-1">
            <li>Empresa: BIXMO SRL</li>
            <li>Dirección: Chisinau, Moldova</li>
            <li>Email: gatherplay.application@gmail.com</li>
          </ul>
        </div>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold text-gray-800 mb-4">2. Información que Recopilamos</h2>
        
        <h3 className="text-xl font-semibold text-gray-700 mb-3">2.1 Información que NO Recopilamos</h3>
        <p className="mb-4">
          GatherPlay está diseñado con la privacidad en mente. No requerimos registro de usuario, y no recopilamos información personal como:
        </p>
        <ul className="list-disc pl-6 mb-4 space-y-1">
          <li>Nombres, direcciones de correo electrónico o números de teléfono</li>
          <li>Información demográfica</li>
          <li>Datos de ubicación más allá de análisis básicos a nivel de país</li>
        </ul>

        <h3 className="text-xl font-semibold text-gray-700 mb-3">2.2 Información que Sí Recopilamos</h3>
        <p className="mb-3"><strong>Información Recopilada Automáticamente:</strong></p>
        <ul className="list-disc pl-6 mb-4 space-y-1">
          <li><strong>Información del Dispositivo:</strong> Tipo de dispositivo, versión del sistema operativo, versión de la app</li>
          <li><strong>Análisis de Uso:</strong> Cómo interactúas con la app, funciones utilizadas, duración de la sesión (recopilado a través de Amplitude)</li>
          <li><strong>Datos Técnicos:</strong> Informes de errores y métricas de rendimiento para mejorar la estabilidad de la app</li>
        </ul>

        <p className="mb-3"><strong>Almacenamiento Local del Dispositivo:</strong></p>
        <ul className="list-disc pl-6 mb-4 space-y-1">
          <li><strong>ID del Jugador:</strong> Un identificador generado aleatoriamente almacenado localmente en tu dispositivo para asegurar que los escenarios del juego no se repitan para el mismo jugador</li>
          <li><strong>Preferencias del Juego:</strong> Configuraciones y preferencias que configures dentro de la app</li>
        </ul>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold text-gray-800 mb-4">3. Cómo Usamos la Información</h2>
        <p className="mb-4">Utilizamos la información recopilada para:</p>
        <ul className="list-disc pl-6 space-y-1">
          <li>Mejorar el rendimiento de la app y corregir errores</li>
          <li>Entender cómo los usuarios interactúan con GatherPlay para mejorar la experiencia de juego</li>
          <li>Asegurar que los escenarios del juego no se repitan para jugadores individuales</li>
          <li>Mostrar anuncios relevantes (en la versión gratuita)</li>
        </ul>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold text-gray-800 mb-4">4. Compartición y Divulgación de Información</h2>
        <p className="mb-3"><strong>Servicios de Terceros:</strong></p>
        <ul className="list-disc pl-6 mb-4 space-y-1">
          <li><strong>Amplitude:</strong> Usamos Amplitude para análisis para entender el uso de la app y mejorar la experiencia del usuario</li>
          <li><strong>Google Ads:</strong> Mostramos anuncios a través de la red publicitaria de Google en la versión gratuita de la app</li>
          <li><strong>Tiendas de Apps:</strong> Las estadísticas de uso básicas pueden compartirse con Apple App Store y Google Play Store como parte de sus análisis estándar</li>
        </ul>
        <p>No vendemos, intercambiamos o transferimos tu información a terceros más allá de estos proveedores de servicios.</p>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold text-gray-800 mb-4">5. Publicidad</h2>
        <p>
          La versión gratuita de GatherPlay muestra anuncios proporcionados por Google Ads. Estos anuncios pueden basarse en 
          demografía general e intereses pero no utilizan información personal recopilada de nuestra app. Puedes actualizar a la versión 
          premium para eliminar todos los anuncios a través de una compra dentro de la app.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold text-gray-800 mb-4">6. Seguridad de Datos</h2>
        <p>
          Implementamos medidas técnicas y organizacionales apropiadas para proteger la información contra acceso no autorizado, 
          alteración, divulgación o destrucción. Dado que recopilamos datos mínimos, tu riesgo de privacidad se reduce significativamente.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold text-gray-800 mb-4">7. Privacidad de Menores</h2>
        <p>
          GatherPlay es adecuado para usuarios de 6 años en adelante. No recopilamos conscientemente información personal de menores. 
          Si eres padre o tutor y crees que tu hijo nos ha proporcionado información personal, contáctanos en 
          gatherplay.application@gmail.com.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold text-gray-800 mb-4">8. Retención de Datos</h2>
        <ul className="list-disc pl-6 space-y-1">
          <li><strong>Datos de Análisis:</strong> Retenidos hasta 2 años para analizar tendencias y mejorar el servicio</li>
          <li><strong>Datos Locales del Dispositivo:</strong> Almacenados localmente en tu dispositivo y pueden eliminarse desinstalando la app</li>
          <li><strong>Datos Técnicos:</strong> Informes de errores y datos de rendimiento retenidos hasta 1 año</li>
        </ul>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold text-gray-800 mb-4">9. Tus Derechos</h2>
        <p className="mb-4">Tienes derecho a:</p>
        <ul className="list-disc pl-6 space-y-1">
          <li>Solicitar información sobre qué datos hemos recopilado (limitado como se describe arriba)</li>
          <li>Solicitar la eliminación de tus datos contactándonos</li>
          <li>Optar por no participar en análisis deshabilitándolos en la configuración de tu dispositivo</li>
        </ul>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold text-gray-800 mb-4">10. Transferencias Internacionales de Datos</h2>
        <p>
          Nuestro proveedor de análisis (Amplitude) puede procesar datos en países distintos a Moldova. Aseguramos que se 
          implementen las salvaguardas apropiadas para cualquier transferencia internacional de datos.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold text-gray-800 mb-4">11. Cambios a Esta Política de Privacidad</h2>
        <p>
          Podemos actualizar esta Política de Privacidad de vez en cuando. Te notificaremos de cualquier cambio publicando la nueva 
          Política de Privacidad dentro de la app y actualizando la fecha de "Última Actualización". El uso continuo del Servicio después 
          de los cambios constituye la aceptación de la política actualizada.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold text-gray-800 mb-4">12. Contáctanos</h2>
        <p className="mb-4">Si tienes alguna pregunta sobre esta Política de Privacidad, contáctanos:</p>
        <ul className="list-disc pl-6 space-y-1">
          <li>Email: gatherplay.application@gmail.com</li>
          <li>Empresa: BIXMO SRL, Chisinau, Moldova</li>
        </ul>
      </section>

      <div className="bg-blue-50 p-4 rounded-lg mt-8">
        <p className="text-sm text-blue-800">
          Esta Política de Privacidad está diseñada para ser transparente sobre nuestras prácticas mínimas de recopilación de datos mientras 
          garantiza el cumplimiento de las leyes de privacidad aplicables, incluyendo GDPR, CCPA y los requisitos de las tiendas de aplicaciones móviles.
        </p>
      </div>
    </div>
  );
};

export default PrivacyPolicyES;